import React, { useState, useCallback, ReactElement, ReactNode } from 'react';
import { useWindowSize } from 'react-use';
import { Box, Collapse } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Icon, AlyceTheme } from '@alycecom/ui';

import StyledSubmitButton from '../Shared/StyledSubmitButton';

const useStyles = makeStyles<AlyceTheme>(({ spacing }) => ({
  root: {
    height: 200,
    overflow: 'hidden',
    transition: 'height .5s, padding .5s',
  },
  button: {
    position: 'absolute',
    bottom: -25,
    left: 'calc(50% - 90px)',
    zIndex: 500,
  },
  buttonIcon: {
    marginRight: spacing(1),
  },
  buttonText: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
  },
}));

export interface IExpanderProps {
  children: ReactNode;
}

const Expander = ({ children }: IExpanderProps): ReactElement => {
  const classes = useStyles();
  const { width } = useWindowSize();
  const [isExpand, setExpand] = useState(false);

  const height = isExpand ? 'auto' : 350;
  const buttonText = isExpand ? 'Read less' : 'Read more';
  const buttonIcon = isExpand ? 'minus' : 'plus';
  const isExpandable = width < 769;

  const expandHandler = useCallback(() => setExpand(isExpanded => !isExpanded), []);

  return isExpandable ? (
    <Box className={classes.root} style={{ height }}>
      <Collapse in={isExpand} collapsedSize={350} timeout={250}>
        <Box>{children}</Box>
      </Collapse>
      <Box className={classes.button}>
        <StyledSubmitButton width={180} onClick={expandHandler}>
          <Box display="flex" flexDirection="row-reverse" justifyContent="space-around" alignItems="center">
            <Icon icon={buttonIcon} className={classes.buttonIcon} />
            <span className={classes.buttonText}>{buttonText}</span>
          </Box>
        </StyledSubmitButton>
      </Box>
    </Box>
  ) : (
    <>{children}</>
  );
};

export default Expander;
